function InitFormPopup() {
  const openBtns = document.querySelectorAll(".openFormPopup");
  const closeBtns = document.querySelectorAll(".closeFormPopup");
  const popupWrapper = document.querySelector(".formPopupWrapper");
  const popupOverlay = document.querySelector(".formPopupOverlay");
  if ((!openBtns.length && !closeBtns.length) || !popupWrapper || !popupOverlay)
    return;
  openBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      popupWrapper.classList.add("active");
      popupOverlay.classList.add("active");
      document.documentElement.classList.add("overflow-hidden");
    });
  });
  closeBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      popupWrapper.classList.remove("active");
      popupOverlay.classList.remove("active");
      document.documentElement.classList.remove("overflow-hidden");
    });
  });
  popupOverlay.addEventListener("click", function () {
    popupWrapper.classList.remove("active");
    popupOverlay.classList.remove("active");
    document.documentElement.classList.remove("overflow-hidden");
  });
}

export default InitFormPopup;